"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskNavigator = exports.getEnabledTasks = exports.getAdjacentTasks = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../styles/theme"));
const Button_1 = require("../button/Button");
const Icon_1 = require("../icon/Icon");
const tasks_1 = require("../../../tasks");
const RoutingContext_1 = require("../../../context/RoutingContext");
const index_1 = require("../../../index");
const types_1 = require("../../../entities/fact/types");
// When not on mobile breakpoint
const NAVIGATOR_WIDTH = 355;
const leftValue = (contentWidth) => {
    if (contentWidth) {
        return `calc(${contentWidth}px - ${NAVIGATOR_WIDTH}px)`;
    }
    else {
        return '30%';
    }
};
const Wrapper = styled_1.default.div `
	// Nothing should overlap this
	z-index: ${theme_1.default.layout.zIndex.taskNavigator};
	height: 80px;
	position: fixed;
	bottom: 0;
	width: ${NAVIGATOR_WIDTH}px;
	padding-top: ${theme_1.default.layout.spacing.standard};
	padding-bottom: ${theme_1.default.layout.spacing.standard};
	border: ${theme_1.default.colours.neutral.light} 1px solid;
	border-bottom: 0;
	background-color: ${theme_1.default.colours.neutral.white};

	@media only screen and (max-width: 760px) {
		width: 100%;
		left: 0;
		right: 0;

		// Reduce padding on mobile to keep buttons in single line
		.task-navigator__btn-right .merlin-button,
		.task-navigator__btn-left .merlin-button {
			padding: 5px 10px;
		}

	}

	@media only screen and (max-width: 1023px) {
		height: 136px;
	}

	@media only screen and (min-width: 761px) {
		left: ${(props) => leftValue(props.contentWidth)};
	}

	.task-navigator__icon {
		width: 15px;
		height: 15px;
		position: relative;
	}

	.task-navigator__btn-left {
		float: left;
		padding-right: ${theme_1.default.layout.spacing.standard};
		padding-left: ${theme_1.default.layout.spacing.standard};

		.task-navigator__icon {
			left: -5px;
		}
	}

	.task-navigator__btn-right {
		float: right;
		padding-right: ${theme_1.default.layout.spacing.standard};

		.task-navigator__icon {
			left: 5px;
		}
	}
`;
const StyledButtonContent = styled_1.default.span `
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
const getAdjacentTasks = (current, capabilities, property) => {
    const enabledTasks = (0, exports.getEnabledTasks)(capabilities, property || undefined);
    const currentIndex = enabledTasks.indexOf(current);
    return { prevTask: tasks_1.TaskDetails[enabledTasks[currentIndex - 1]], nextTask: tasks_1.TaskDetails[enabledTasks[currentIndex + 1]] };
};
exports.getAdjacentTasks = getAdjacentTasks;
const getEnabledTasks = (capabilities, property) => {
    return Object.keys(tasks_1.TaskDetails).filter((key) => {
        const overlay = tasks_1.TaskDetails[key].overlay ? tasks_1.TaskDetails[key].overlay(capabilities, property) : {};
        return ![types_1.TaskCompletionState.DISABLED, types_1.TaskCompletionState.HIDDEN].includes(overlay === null || overlay === void 0 ? void 0 : overlay.completion);
    });
};
exports.getEnabledTasks = getEnabledTasks;
const TaskNavigator = (props) => {
    const { baseUrl } = React.useContext(RoutingContext_1.RouterContext);
    const { capabilities, appMode } = React.useContext(index_1.AppContext);
    const { prevTask, nextTask } = (0, exports.getAdjacentTasks)(props.task, capabilities, props.property);
    // If either next or prev task is undefined it means we're on the very first or very last task.
    // In this case the expected behaviour is for the button to redirect to the dashboard.
    /**
     * * Relative paths here are linked to the react-router-dom v6 + react 18 upgrade
     * * We could no longer use the `taskUrl` function as routing is now handled relatively instead of absolutely.
     * * This means that we need to hard code the relative path we want to navigate to instead.
     */
    const prevUrl = baseUrl + (prevTask !== undefined ? `/../${prevTask.routeName}` : `../../../../${appMode}`);
    const nextUrl = baseUrl + (nextTask !== undefined ? `/../${nextTask.routeName}` : `../../../../${appMode}`);
    return (React.createElement(Wrapper, { contentWidth: props.contentWidth },
        React.createElement("div", null,
            React.createElement("div", { className: "task-navigator__btn-left" },
                React.createElement(Button_1.LinkButton, { to: prevUrl, "data-testid": "prev-btn" },
                    React.createElement(StyledButtonContent, null,
                        React.createElement("span", { className: "task-navigator__icon" },
                            React.createElement(Icon_1.Icon, { icon: "left", colour: "black" })),
                        React.createElement("span", null, "Previous")))),
            React.createElement("div", { className: "task-navigator__btn-right" },
                React.createElement(Button_1.LinkButton, { buttonType: Button_1.PresetThemes.Primary, to: nextUrl, "data-testid": "next-btn" },
                    React.createElement(StyledButtonContent, null,
                        React.createElement("span", null, "Next section"),
                        React.createElement("span", { className: "task-navigator__icon" },
                            React.createElement(Icon_1.Icon, { icon: "right", colour: "white" }))))))));
};
exports.TaskNavigator = TaskNavigator;
//# sourceMappingURL=TaskNavigator.js.map